import { Avatar } from "antd";
import React from "react";

const ProfilePic = ({ name, image }) => {
  const nameInitials = name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();

  return (
    <div>
      {image ? (
        <Avatar size="large" src={image} />
      ) : (
        <Avatar
          size="large"
          style={{ backgroundColor: "var(--primary-background)" }}
        >
          {nameInitials}
        </Avatar>
      )}
    </div>
  );
};

export default ProfilePic;
